"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _Functions = require("UIComponents/core/Functions");

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _default = _react.default.createClass({
  displayName: "UIRouterLink",
  propTypes: (0, _extends2.default)({
    activeClassName: _react.PropTypes.string.isRequired,
    activeStyle: _react.PropTypes.object,
    children: _react.PropTypes.node.isRequired,
    className: _react.PropTypes.string,
    onClick: _react.PropTypes.func,
    onlyActiveOnIndex: _react.PropTypes.bool.isRequired,
    style: _react.PropTypes.object.isRequired,
    to: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.shape({
      pathname: _react.PropTypes.string,
      query: _react.PropTypes.object,
      hash: _react.PropTypes.string,
      state: _react.PropTypes.object
    })])
  }, _UILink.default.propTypes),
  contextTypes: {
    router: _react.PropTypes.object
  },
  getDefaultProps: function getDefaultProps() {
    return (0, _extends2.default)({
      activeClassName: 'private-router-link--active',
      onlyActiveOnIndex: false,
      style: {}
    }, _UILink.default.defaultProps);
  },
  isActive: function isActive(_ref) {
    var onlyActiveOnIndex = _ref.onlyActiveOnIndex,
        to = _ref.to;
    return this.context.router.isActive(to, onlyActiveOnIndex);
  },
  handleClick: function handleClick(e) {
    var onClick = this.props.onClick;
    (0, _Functions.callIfPossible)(onClick, e);

    if (e.defaultPrevented) {
      return;
    }

    (0, _invariant.default)(this.context.router, '<UIRouterLink>s rendered outside of a router context cannot navigate.');

    if (e && !e.metaKey) {
      e.preventDefault();
      this.context.router.push(this.props.to);
    }
  },
  render: function render() {
    var _this$props = this.props,
        activeClassName = _this$props.activeClassName,
        activeStyle = _this$props.activeStyle,
        children = _this$props.children,
        className = _this$props.className,
        __onClick = _this$props.onClick,
        onlyActiveOnIndex = _this$props.onlyActiveOnIndex,
        style = _this$props.style,
        to = _this$props.to,
        rest = (0, _objectWithoutProperties2.default)(_this$props, ["activeClassName", "activeStyle", "children", "className", "onClick", "onlyActiveOnIndex", "style", "to"]);
    var isActive = this.isActive({
      onlyActiveOnIndex: onlyActiveOnIndex,
      to: to
    });
    var classes = (0, _classnames.default)(className, 'private-router-link', (0, _defineProperty2.default)({}, activeClassName, isActive));
    return _react.default.createElement(_UILink.default, (0, _extends2.default)({}, rest, {
      "aria-current": isActive ? 'page' : null,
      className: classes,
      href: this.context.router.createHref(to),
      onClick: this.handleClick,
      style: (0, _extends2.default)({}, style, isActive ? activeStyle : null)
    }), children);
  }
});

exports.default = _default;
module.exports = exports.default;